import { HTMLDataTrackerProps } from '@/app/types';
import { getWrapperMaxWidth, SectionFit } from '@/cms/utils';
import { cn } from '@/lib/utils';

type DataTrackerSectionProp = Required<
  Pick<HTMLDataTrackerProps, 'data-tracker-section'>
>;

export type BlockWrapperProps = {
  children: React.ReactNode;
  contentFit?: SectionFit;
  classNames?: {
    root?: string;
    inner?: string;
  };
} & DataTrackerSectionProp;

export function BlockWrapper({
  children,
  contentFit = 'contained',
  classNames,
  ...rest
}: BlockWrapperProps) {
  return (
    <>
      <section
        {...rest}
        className={cn(
          'bg-gray-25 w-full px-5 py-8 md:px-10 md:py-[3.75rem] lg:py-20',
          classNames?.root
        )}
      >
        <div
          className={cn(
            getWrapperMaxWidth(contentFit),
            'mx-auto my-0',
            classNames?.inner
          )}
        >
          {children}
        </div>
      </section>
    </>
  );
}
